import { render, staticRenderFns } from "./ProjectQualityReport.vue?vue&type=template&id=7e97f375&scoped=true"
import script from "./ProjectQualityReport.vue?vue&type=script&lang=js"
export * from "./ProjectQualityReport.vue?vue&type=script&lang=js"
import style0 from "./ProjectQualityReport.vue?vue&type=style&index=0&id=7e97f375&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e97f375",
  null
  
)

export default component.exports